"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLinkAlternate(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m10.4744 13.5256c.4436.4219.4436 1.1144 0 1.5363-.4219.422-1.11438.422-1.53634 0-2.10982-2.1098-2.10982-5.53958 0-7.6494l3.83014-3.83014c2.1098-2.10981 5.5396-2.10981 7.6494 0 2.1099 2.10982 2.1099 5.53963 0 7.64944l-1.6121 1.6121c.0108-.8872-.1298-1.7744-.4328-2.6183l.5086-.51935c1.2767-1.26589 1.2767-3.32161 0-4.58751-1.2659-1.27671-3.3217-1.27671-4.5875 0l-3.8194 3.81932c-1.27667 1.26584-1.27667 3.32164 0 4.58754zm3.0512-4.58754c.4219-.42197 1.1144-.42197 1.5363 0 2.1099 2.10984 2.1099 5.53964 0 7.64944l-3.8301 3.8301c-2.10981 2.1099-5.53962 2.1099-7.64944 0-2.10981-2.1098-2.10981-5.5396 0-7.6494l1.61212-1.6121c-.01082.8872.12984 1.7744.43279 2.6291l-.50853.5086c-1.27671 1.2658-1.27671 3.3216 0 4.5875 1.2659 1.2767 3.32162 1.2767 4.58751 0l3.81935-3.8194c1.2767-1.2658 1.2767-3.3216 0-4.5875-.4436-.4219-.4436-1.11438 0-1.53634z"
  }));
}

var _default = SvgLinkAlternate;
exports["default"] = _default;